import styled from "styled-components";
import Button from "./Button";
import RightArrowIcon from "./icons/RightArrow";
import LeftArrowIcon from "./icons/LeftArrow";

export const SingleCircle = styled.div`
  height: 55px;
  width: 55px;

  @media (min-width: 1800px) {
    height: 80px;
    width: 80px;
  }

  @media (max-width: 575px) {
    height: 72.48px;
    width: 72.48px;
  }
`;
export const SingleCircleLocationCard = styled.div`
  height: 55px;
  width: 55px;

  @media (min-width: 1800px) {
    height: 65px;
    width: 65px;
  }

  @media (max-width: 575px) {
    height: 57px;
    width: 57px;
  }
`;

export const SingleCircleDetail = styled.div`
  text-align: center;
  font-size: 9px;
  line-height: 14px;
  margin-top: 7.5px;
  color: ${props => props.theme.text};

  @media (min-width: 1800px) {
    font-size: 12px;
    line-height: 21px;
    margin-top: 10px;
  }

  @media (max-width: 575px) {
    font-size: 12px;
    line-height: 21px;
    margin-top: 5px;
  }
`;

export const CircleAndDetail = styled.div`
  width: min-content;
  margin: 0 2% 5%;
`;

export const Main = styled.div`
  width: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
  background-color: ${props => props.theme.background};
  transition: background-color ease 1s;
  @media (max-width: 575px) {
    margin-bottom: 20vh;
  }
  ::after {
    content: "";
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    min-height: 100vh;
    transition: background-color ease 1s;
    background: ${props => props.theme.background};
    z-index: -1;
  }
`;

export const GraphDetailContainer = styled.div`
  margin-left: 23.5%;
  margin-right: 5%;
  display: flex;

  @media (min-width: 1800px) {
    margin-left: 22.7%;
  }
  @media (max-width: 575px) {
    width: 100%;
    margin-right: 0;
    margin-left: 0;
  }
`;

export const SliderContainer = styled.div`
  margin: 4vh 6% 0 6%;
  @media (max-width: 575px) {
    width: 90%;
    margin: 45px auto 0;
  }
  @media (min-width: 1800px) {
    margin: 15px 6% 0 6%;
  }
`;

export const ZoomedSliderContainer = styled.div`
  margin: 0 6% 0 6%;
  @media (max-width: 575px) {
    width: 90%;
    margin: 45px auto 0;
  }
  @media (min-width: 1800px) {
    margin: 2vh 6% 0 6%;
  }
`;

export const MainArea = styled.div`
  margin-top: 7%;
  margin-bottom: 4%;
  width: 75%;
  @media (min-width: 1800px) {
    width: 90%;
  }
  @media (max-width: 575px) {
    width: 100%;
  }
`;

export const DetailArea = styled.div`
  width: 25%;
  padding: 0 30px;
  @media (min-width: 1800px) {
    padding: 0 36px;
    max-height: 100vh;
    overflow: hidden;
  }
  @media (max-width: 575px) {
    visibility: ${props => (props.mobileShow ? "visible" : "hidden")};
    left: ${props => (props.mobileShow ? 0 : "-100%")};
    transition: left ease-in-out 0.4s, visibility ease-in-out 0.4s;
    position: absolute;
    width: 100%;
    height: 76vh;
    box-sizing: border-box;
    background-color: ${props => props.theme.backgroundSecondary};
    z-index: 2;
    border-bottom: 1px solid ${props => props.theme.border};
    border-top: 1px solid ${props => props.theme.border};
  }
`;

export const MainText = styled.div`
  font-family: "dubai-medium";
  font-size: 20px;
  color: ${props => props.theme.text};
  text-align: right;
  margin-top: 15%;
  line-height: 26px;
  opacity: 0.5;
  @media (min-width: 1800px) {
    font-size: 30px;
    line-height: 48px;
  }
`;

export const Title = styled.div`
  font-family: "dubai-bold";
  font-size: 15px;
  color: ${props => props.theme.textHighlight};
  text-align: right;
  margin-top: 12%;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
    margin-top: 18px;
  }

  @media (max-width: 575px) {
    font-family: "dubai-medium";
    font-size: 14px;
    line-height: 24px;
    margin-top: 4%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const Description = styled.div`
  font-size: 12px;
  color: ${props => props.theme.text};
  text-align: right;
  margin: 5% 0 10% 0;
  line-height: 18px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 30px;
  }
  @media (max-width: 575px) {
    display: none;
  }
`;

export const GraphDescription = styled.div`
  text-align: center;
  color: ${props => props.theme.text};
  font-size: 12px;
  margin: 3% 0;
  @media (min-width: 1800px) {
    font-size: 21px;
    margin: 25px 0;
  }

  @media (max-width: 575px) {
    font-size: 14px;
    margin-top: 40px;
  }
`;

export const DropDownButton = styled(Button)`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 5px 14px;
  margin: ${props => (props.size === "small" ? "0 auto 10%" : "10% auto")};
  align-items: center;
  height: fit-content;
  color: ${props => (props.open ? props.theme.white : props.theme.text)};
  font-family: ${props => (props.open ? "dubai-bold" : "dubai-regular")};
  @media (min-width: 1800px) {
    font-size: 21px;
    width: 100%;
    height: ${props => (props.size === "small" ? "40px" : "50px")};
    padding: ${props => (props.size === "small" ? " 0 15px" : "0 25px")};
    padding: 0 25px;
  }
`;

export const DropdownGraphContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-around;
  padding: ${props => (props.background ? "15px 8px" : 0)};
  background-color: ${props =>
    props.background ? props.theme.backgroundSecondary : "transparent"};
  transition: background-color ease 1s;
  border-radius: 25px;

  @media (max-width: 575px) {
    max-height: 35vh;
    overflow: auto;
    background-color: ${props =>
      props.background ? props.theme.background : "transparent"};
  }

  &::-webkit-scrollbar {
    width: 5px;
    margin: 5px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.backgroundSecondary};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(46, 112, 116, 0.5);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(46, 112, 116);
  }
`;

export const DropdownGraphChild = styled.div`
  cursor: pointer;
  opacity: ${props => (props.selected ? 1 : 0.3)};
  flex: 1 1 30%;
  text-align: center;
`;
export const PageDetail = styled.div`
  display: flex;
  justify-content: center;
  color: ${props => props.theme.textHighlight};
  margin-top: 10px;
  @media (min-width: 1800px) {
    font-size: 14px;
    line-height: 24px;
  }
`;

export const GraphTitle = styled.div`
  display: flex;
  justify-content: center;
  color: ${props => props.theme.textHighlight};
  margin-top: 35px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 24px;
  }

  @media (max-width: 575px) {
    margin-top: 20px;
    margin-bottom: 15px;
    font-size: 12px;
  }
`;

export const CountData = styled.div`
  display: flex;
  justify-content: center;
  color: ${props => props.theme.textHighlight};
  font-family: "dubai-bold";
  font-size: 19px;
  margin-top: 8px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
  @media (max-width: 575px) {
    margin-top: 40px;
    font-size: 18px;
  }
`;

export const CircleGraphsTitle = styled.div`
  display: flex;
  justify-content: center;
  color: ${props => props.theme.textHighlight};
  font-size: 15px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
  @media (max-width: 575px) {
    font-size: 12px;
    margin-top: 6vh;
  }
`;

export const CirclesGraphContainer = styled.div`
  display: flex;
  padding: 30px 30px 0 30px;
  justify-content: center;
  flex-wrap: wrap;

  @media (min-width: 1800px) {
    padding: 30px 0 0;
  }

  @media (max-width: 575px) {
    flex-wrap: nowrap;
    text-align: center;
    margin: 0;
    max-width: 100%;
    overflow: auto;
    justify-content: left;
    padding: 20px 0 0 0;
  }
`;

export const LocationCirclesGraphContainer = styled.div`
  display: flex;
  padding-top: 30px;
  justify-content: center;
  flex-wrap: wrap;

  @media (min-width: 1800px) {
    padding: 30px 10% 0;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10%;
  @media (min-width: 1800px) {
    padding: 0px;
  }
  @media (max-width: 575px) {
    padding: 0 40px 0 15%;
    margin-top: 8%;
  }
`;

export const SwitchButtonsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10%;

  @media (max-width: 575px) {
    margin-bottom: 7%;
  }
`;

export const SwitchButton = styled(Button)`
  width: 47%;
  padding: 5px 4px;
  font-size: 12px;
  font-family: ${props => (props.outlined ? "dubai-medium" : "dubai-regular")};

  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
    height: 40px;
    padding: 0 10px;
  }
  @media (max-width: 575px) {
    font-size: 14px;
    line-height: 24px;
    height: 30px;
    padding: 0;
  }
`;

export const MapExplainText = styled.span`
  color: ${props => props.theme.text};
  margin-bottom: 30px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 30px;
  }

  @media (max-width: 575px) {
    margin-bottom: 18px;
    font-size: 12px;
  }
`;

export const RightContainer = styled.div`
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  width: 23%;
  background-color: ${props => props.theme.backgroundSecondary};
  transition: background-color ease 1s;
  display: flex;
  flex-direction: column;
  text-align: right;
  @media (max-width: 575px) {
    width: 100%;
  }
`;

export const TitleAction = styled.div`
  height: 12%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding-right: 10%;
  border-bottom: 1px solid ${props => props.theme.border};
  @media (min-width: 1800px) {
    padding-top: 14px;
    padding-bottom: 16px;
  }
`;

export const TextContainer = styled.div`
  margin-right: 10%;
  margin-top: 5px;
  font-size: 15px;
  color: ${props => props.theme.textHighlight};
  display: flex;
  flex-direction: column;
  @media (min-width: 1800px) {
    font-size: 30px;
    line-height: 51px;
  }
`;

export const ZoomedTitle = styled.span`
  font-family: "dubai-bold";
  font-size: 15px;

  @media (min-width: 1800px) {
    font-size: 30px;
    line-height: 51px;
  }
`;

export const ZoomedActionsContainer = styled.div`
  color: ${props => props.theme.text};
  display: flex;
  flex-direction: column;
  padding: 8% 10% 0 30%;
  height: fit-content;
  @media (min-width: 1800px) {
    padding: 8% 15% 0 10%;
    p {
      font-size: 18px;
      line-height: 30px;
    }
  }
`;

export const ActionsTitle = styled.div`
  color: ${props => props.theme.textHighlight};
  font-size: 15px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
`;

export const SecondActionsTitle = styled(ActionsTitle)`
  margin: 20px 0;
`;

export const Overlay = styled.div`
  background-color: transparent;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 7%;
  margin-left: 23%;
  margin-right: 23%;
  @media (min-width: 1800px) {
    text-align: center;
  }
`;

export const LocationDetailContainer = styled.div`
  position: absolute;
  left: ${props => -55 * props.cardNo - 29}vw;
  transition: left ease 1s, bottom ease 1s;

  bottom: ${props => (props.isSwipedUp ? 0 : "-25%")};
  min-width: 100%;
  display: flex;
  justify-content: center;
  @media (max-width: 575px) {
    left: ${props => -90 * props.cardNo - 85}vw;
  }
`;

export const LocationDetail = styled.div`
  width: 54vw;
  height: fit-content;
  border-radius: 49px;
  background-color: ${props => props.theme.backgroundTertiary};
  transition: background-color ease 1s;
  margin: 0 0.5%;
  display: flex;
  justify-content: center;

  align-items: center;
  flex-direction: column;
  @media (min-width: 1800px) {
  }
`;
export const TopHandle = styled.div`
  width: 50px;
  height: 5px;
  background-color: #707070;
  margin-top: 15px;
  border-radius: 10px;
`;

export const RightArrowIconSt = styled(RightArrowIcon)`
  cursor: pointer;
  margin-top: 10%;
  margin-left: -15px;
  z-index: 2;
`;
export const LeftArrowIconSt = styled(LeftArrowIcon)`
  cursor: pointer;
  margin-top: 10%;
  margin-right: -15px;
  z-index: 2;
`;

export const ZoomedMainArea = styled.div`
  width: 75%;
  margin-top: ${props => (props.isOverlay ? 0 : "7%")};

  @media (max-width: 575px) {
    width: 90%;
    margin-top: 0;
    margin: 0px auto;
  }
`;

export const ZoomedGraphContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 20px;
  @media (min-width: 1800px) {
    justify-content: center;
  }
`;

export const LocationCircleGraphsTitle = styled(CircleGraphsTitle)`
  @media (max-width: 575px) {
    margin: 0;
  }
`;
